interface PaginationProps {
  routeStatePage: number | string;
  href: string;
}

const pagination = (props: PaginationProps) => {
  const { routeStatePage, href } = props;

  const newUrl = new URL(href);

  if (newUrl.searchParams.has('page')) {
    return href;
  }

  newUrl.searchParams.set('page', String(routeStatePage));

  return decodeURI(newUrl.toString());
};

export default pagination;
